export const INSTALL_MOBILE_APPLICATION_MODAL_NAME = 'installMobileApplication';
